/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserItem } from '../../models/user-item';

export interface IdentityControllerActivateUser$Params {
  code: string;
}

export function identityControllerActivateUser(http: HttpClient, rootUrl: string, params: IdentityControllerActivateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerActivateUser.PATH, 'patch');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserItem;
      }>;
    })
  );
}

identityControllerActivateUser.PATH = '/identity/activate/{code}';
